import { useEffect, useState } from 'react';
import { api } from '../../../../services/api';
import { useWorkspace } from '../../WorkspaceContext';
import WeeklyHoursEditor from '../../components/WeeklyHoursEditor';

export const DEFAULT_WORKING_HOURS = {
  monday: { open: '09:00', close: '18:00', closed: false },
  tuesday: { open: '09:00', close: '18:00', closed: false },
  wednesday: { open: '09:00', close: '18:00', closed: false },
  thursday: { open: '09:00', close: '18:00', closed: false },
  friday: { open: '09:00', close: '18:00', closed: false },
  saturday: { open: '09:00', close: '17:00', closed: false },
  sunday: { open: '09:00', close: '17:00', closed: true },
};

// Location working hours drive when the calendar is open for bookings.
// Outside these hours nothing is offered; inside them, only owner blocks
// and existing appointments remove individual slots.
const ManageHours = () => {
  const { activeLocation, refresh } = useWorkspace();
  const [draft, setDraft] = useState(DEFAULT_WORKING_HOURS);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (activeLocation?.workingHours) {
      setDraft(activeLocation.workingHours);
    } else {
      setDraft(DEFAULT_WORKING_HOURS);
    }
    setSaved(false);
    setError('');
  }, [activeLocation?.id, activeLocation?.workingHours]);

  const save = async () => {
    if (!activeLocation) return;
    setSaving(true);
    setError('');
    const result = await api.updateWorkspaceLocation(activeLocation.id, {
      workingHours: draft,
    });
    setSaving(false);

    if (result.error) {
      setError(result.error);
      return;
    }

    setSaved(true);
    await refresh();
  };

  return (
    <div className="min-w-0">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div className="min-w-0">
          <h2 className="font-display text-2xl font-light text-ink-900 sm:text-3xl">Working hours</h2>
          <p className="mt-1 text-sm text-ink-700/80">
            The calendar at{' '}
            <span className="font-medium text-ink-900">{activeLocation?.name || 'this location'}</span>{' '}
            stays open during these hours. Block specific times from Calendar when you need to close
            a slot.
          </p>
        </div>
        <button
          type="button"
          onClick={save}
          disabled={saving || !activeLocation}
          className="inline-flex flex-none items-center justify-center bg-saffron-500 px-5 py-3 text-sm font-semibold uppercase tracking-[0.12em] text-ink-900 transition-colors hover:bg-saffron-400 disabled:opacity-50"
        >
          {saving ? 'Saving…' : 'Save hours'}
        </button>
      </div>

      {error && (
        <div className="mt-4 border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800">
          {error}
        </div>
      )}
      {saved && !error && (
        <p className="mt-4 text-sm text-ink-700/70">Working hours saved. Booking slots will follow these times.</p>
      )}

      <div className="mt-6">
        <WeeklyHoursEditor value={draft} onChange={(next) => { setDraft(next); setSaved(false); }} />
      </div>
    </div>
  );
};

export default ManageHours;
